module.exports = __webpack_public_path__ + "static/media/email.c9ab2279.webp";